import { render, staticRenderFns } from "./qs2-21.vue?vue&type=template&id=2c17b02c&scoped=true&"
import script from "./qs2-21.vue?vue&type=script&lang=js&"
export * from "./qs2-21.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c17b02c",
  null
  
)

export default component.exports